// extracted by mini-css-extract-plugin
export default {"svgContainer":"SvgContainer4_svgContainer__WEqRV","redSvg":"SvgContainer4_redSvg__mXZzk"};